const getDefaultState = () => {
  return {
    uploadData: {},
  }
}
  
const state = getDefaultState()
const getters = {
  uploadData: state => state.uploadData
}
const mutations = {
  setUploadData (state, data) {
    state.uploadData = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
